module.exports = __webpack_public_path__ + "static/media/reservations-filters-btn-clear.fe7f0720.svg";